import React, { useRef } from 'react'
import { motion, useInView } from "framer-motion"

import { Container } from '../../Container'
import { Action } from '../Action'

import './multiple-images.css'
import './variant-three.css'
import './variant-four.css'
import './variant-five.css'
import ContentfulLongText from '../../ContentfulLongText'

export const MultipleImages = ({ heroContent, pageHeroTitle }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    const getVariantQuantity = (array) => {
        const length = array?.length;
        if (length === 3) {
            return ' variant-three';
        } else if (length === 4) {
            return ' variant-four';
        } else {
            return ' variant-five';
        }
    };
    
    let variantQuantity = getVariantQuantity(heroContent.images);
    let variantVideosQuantity = getVariantQuantity(heroContent.videos);    

    let isCustomize = heroContent.isCustomize ? ' is-customize':''
    return (
        <div ref={ref} className='cover no-repeat pages-hero pages-hero--customized multiple-images overlay' style={{
            backgroundImage: `url(${heroContent.backgroundMedia})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        }}>
            <Container>
                <div className='grid col-5-6 col-1-md gap-15-md gap-49 relative z-2'>
                    {heroContent.videos ? (
                        <div className={`relative videos ${variantVideosQuantity}${variantQuantity}${isCustomize}`}>
                            {heroContent.videos.map((item, index)=> {
                                const videoId = item.videoLink ? item.videoLink.match(/(?:\/|%2F)([A-Za-z0-9_-]{11})/)[1] : '';
                                const youtubeEmbedLink = `https://www.youtube.com/embed/${videoId}`;
                                return (
                                    <div key={index} className='absolute item'>
                                        <iframe 
                                        className={`${variantVideosQuantity === 'variant-five' ? 'hw-200 hw-100-lg hw-100-md':'hw-300 hw-200-lg'} hw-250-sm hw-150-xs rounded-full cursor-pointer`}
                                        src={youtubeEmbedLink} 
                                        title="We Are Savor Brands" 
                                        frameBorder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                        allowFullScreen 
                                        style={{
                                            maxWidth: '100%',
                                            animation: `float 6s ease-in-out infinite`, 
                                            animationDelay: `${index * .9}s`,
                                            opacity: isInView ? 1 : 0,
                                            transition: `all ${.3 * index}s cubic-bezier(0.17, 0.55, 0.55, 1) ${.3 * index}s`
                                        }}></iframe>
                                    </div>
                                )
                            })}
                        </div>
                    ): (
                        <div className={`relative images ${variantQuantity}${isCustomize}`}>
                            {heroContent.images.map((item, index) => (
                                <img 
                                key={index} 
                                src={item.gatsbyImageData.images.fallback.src} 
                                className='absolute rounded-full' 
                                alt={`${heroContent.pageTitle} ${index}` || 'Multiple Media Item'} 
                                style={{
                                    maxWidth: '100%',
                                    animation: `float 6s ease-in-out infinite`, 
                                    animationDelay: `${index * .9}s`,
                                    opacity: isInView ? 1 : 0,
                                    transition: `all ${.3 * index}s cubic-bezier(0.17, 0.55, 0.55, 1) ${.3 * index}s`
                                }}
                                />
                            ))}
                        </div>
                    )}
                    <motion.div initial={{ opacity: 0, x: 100 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1 }} className='content'>
                        <h1><span>{pageHeroTitle}</span></h1>
                        <ContentfulLongText longTextContent={heroContent.content.content} />
                        <Action hasButtonConfiguration={!!heroContent.buttonConfig} actionData={heroContent.buttonConfig} />
                    </motion.div>
                </div>
            </Container>
        </div>
    )
}